import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const branchRoleURL = `api/v1/auth/branch/branch-role`;

//obtaining the paginated data
export const getBranchRole = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${branchRoleURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllBranchRole = () => axiosInstance.get(`${branchRoleURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageBranchRole = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${branchRoleURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getBranchRoleById = (id) => axiosInstance.get(`${branchRoleURL}/retrieve/${id}`);

export const loadOptionsBranchRolePermission = (categoryId, branchId) =>
  axiosInstance.get(`api/v1/auth/branch/branch-permission/list?category=${categoryId}&branch=${branchId}`);

//creating function
export const createBranchRole = (body) => axiosInstance.post(`${branchRoleURL}/create`, body);
//updating function
export const updateBranchRole = (id, body) => axiosInstance.patch(`${branchRoleURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${branchRoleURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPermissionName = (e, cancelToken) =>
  axiosInstance.get(`${branchRoleURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
